import React, { useState, useEffect } from "react"
import { CardContainer, Thumb, Image, Rating, Info, Title, Date } from "./styles/card"
import { Icon } from "../../components"
import Color from "../../constants/Color"

export default function MovieCard({ children, to, rest }) {
  return (
    <CardContainer to={to} {...rest}>
      {children}
    </CardContainer>
  )
}

MovieCard.Thumb = function MovieCardThumb({ children, rate, rest }) {
  const [color, setColor] = useState("")
  let number = parseInt(rate)
  useEffect(() => {
    if (number < 4) {
      setColor(Color.bad)
    } else if (number > 3.9 && number < 7) {
      setColor(Color.ok)
    } else if (number > 6.9 && number < 8) {
      setColor(Color.great)
    } else if (number > 7.9) {
      setColor(Color.superb)
    }

    // eslint-disable-next-line
  }, [number])
  return (
    <Thumb {...rest} color={color}>
      {children}
    </Thumb>
  )
}
MovieCard.Rating = function MovieCardRating({ rate, count, rest }) {
  const [color, setColor] = useState("")
  const [bgColor, setBgColor] = useState()
  let number = parseInt(rate)
  useEffect(() => {
    if (rate && number < 4) {
      setColor(Color.bad)
      setBgColor(Color.badBg)
    } else if (number > 3.9 && number < 7) {
      setColor(Color.ok)
      setBgColor(Color.okBg)
    } else if (number > 6.9 && number < 8) {
      setColor(Color.great)
      setBgColor(Color.greatBg)
    } else if (number > 7.9) {
      setColor(Color.superb)
      setBgColor(Color.superbBg)
    } else {
      setColor(Color.white)
    }

    // eslint-disable-next-line
  }, [number])

  return (
    <Rating {...rest} bg={bgColor} count={count} color={color}>
      {count ? "" : <Icon name="ph-star-fill" pt="1" mr="4" color={color} />}
      <p>{parseFloat(rate).toFixed(1) || parseFloat(count).toFixed(1)}</p>
    </Rating>
  )
}

MovieCard.Image = function MovieCardImage({ path, rest }) {
  return <Image src={path} {...rest} />
}

MovieCard.Info = function MovieCardInfo({ children, isTv, rest }) {
  return (
    <Info {...rest} isTv={isTv}>
      {children}
    </Info>
  )
}

MovieCard.Title = function MovieCardTitle({ children, rest }) {
  return <Title {...rest}>{children}</Title>
}

MovieCard.Date = function MovieCardDate({ children, rest }) {
  return <Date {...rest}>{children}</Date>
}
